<template>
    <div>
        <div class="actions-layout__title">
            <common-icon v-if="iconName" :name="iconName" size="super-large"></common-icon>

            <common-page-header :heading="title" size="larger" contentSpacing="small" :isCenter="true">
                <template #content>
                    <slot name="subtitle"></slot>
                </template>
            </common-page-header>
        </div>

        <common-message v-if="message?.text" :type="message.type">{{ message.text }}</common-message>

        <main>
            <common-content-wrapper class="actions-layout__content" width="large">
                <slot name="content"></slot>
            </common-content-wrapper>
        </main>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String, required: true },
            message: { type: Object, default: null },
            iconName: { type: String, default: undefined },
        },
    }
</script>
